import type {XyiconFeature} from "../../../../../generated/api/base";
import {simpleFilterPositions} from "./SimpleFilterPositions";

export const getFieldRefIdsAboveSeparator = (feature: XyiconFeature): Set<string> => new Set<string>(simpleFilterPositions[feature] ?? []);
